import React, { Suspense } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import appInfo from './app-info';
import routes from './app-routes';
import { SingleCard } from './layouts';
import { Footer } from './components';
import { useTabNavigation } from './contexts/tab-navigation';

import BootstrapTabs from './BootstrapTabs';

import DocImzalaPage from './pages/DOCSABLON/DocImzalaPage';

const RouteFallback = () => (
  <div style={{ padding: 24, color: '#666' }}>Yükleniyor…</div>
);

// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  const { tabs, activeTabIndex, setActiveTabIndex, closeTab } = useTabNavigation();
  const [localTabIndex, setLocalTabIndex] = React.useState(activeTabIndex);
  React.useEffect(() => {
    setLocalTabIndex(activeTabIndex);
  }, [activeTabIndex, tabs.length]);
  const location = useLocation();

  // Eğer imzala sayfası ise sadece onu render et
  if (/^\/docsablon\/imzala\//i.test(location.pathname)) {
    return <DocImzalaPage />;
  }

  // ...mevcut kod...

  return (
    <SingleCard title={appInfo.title}>
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
        {tabs.length === 0 ? (
          // No tabs open, show default home route
          <div style={{ flex: 1, overflow: 'auto' }}>
            <Suspense fallback={<RouteFallback />}>
              <Switch>
                {routes.map(({ path, component }) => (
                  <Route
                    exact
                    key={path}
                    path={path}
                    component={component}
                  />
                ))}
                <Redirect to={'/home'} />
              </Switch>
            </Suspense>
          </div>
        ) : (
          // Tabs are open, show BootstrapTabs
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 }}>
            <BootstrapTabs />
          </div>
        )}
      </div>
      {<Footer>
        Copyright © 1995-{new Date().getFullYear()} {appInfo.title}
        <br />
      </Footer>}
    </SingleCard>
  );
}
